
<template>
      <div class="ka-box">
        <div class="ka-box-con">
            <div class="ka-conten">
                <img v-if="!ifprizekapiandata" class="pg" :src="'//www.ule.com/app/yxd/event/2019/0730/twelve/images/jika/card'+prizekapiandata.indexpk+'.png'" />
                <img v-if="ifprizekapiandata" class="pg" src="//www.ule.com/app/yxd/event/2019/0730/twelve/images/jika/tanbg2.png" />
                <a data-stat="立即领奖" v-if="!ifprizekapiandata&&!hchengkadaka&&prizekapiandata.indexpk!='13'" @click="takeBoxkalayer(prizekapiandata.pcBatchId)" class="lijiang" href="javascript:void(0);"></a>
                <a data-stat="去一分购"  class="hcheng" v-if="hchengkadaka&&prizekapiandata.indexpk!='13'" :href="yifenlink"></a>
                <a data-stat="锦鲤奖"  class="jinli" v-if="!ifprizekapiandata&&prizekapiandata.indexpk=='14'" :href="yifenlink"></a>
                <div v-if="ifprizekapiandata" class="car-pno" v-html="blessinghtml">
                </div>
            </div>
            <a data-stat="关闭卡片弹层" class="shouxia" @click="shouxiaokapi(1)" href="javascript:void(0);"></a>
        </div>
    </div>
</template>

<script>
export default {
  props:['ifprizekapiandata','prizekapiandata','hchengkadaka','yifenlink','jinlilink'],
  data () {
      return {
        blessing:[
                    '愿你每天<br>出门撞好运！',
                    '永远苗条，<br>花式吃也不胖~',
                    '巴啦啦能量，<br>你的颜值越来越高！',
                    '烦恼消，<br>乐逍遥！',
                    '踏上新旅程，<br>开启新希望！',
                    '笑口常开，<br>事事顺心！',
                    '祝你欧气十足，<br> 幸运滚滚来！',
                    '健康围绕财运罩~',
                    '国家富强，<br>生活更富足~',
                    '升职加薪<br>走上人生巅峰！'
                ],
       blessinghtml:'愿你每天<br>出门撞好运！',//祝福卡文案
      }
    },
    created(){
      var m=this;
      if(m.ifprizekapiandata){
          var nu=Math.floor(Math.random() *(m.blessing.length));
          m.blessinghtml=m.blessing[nu];
      }
    }, 
    methods:{
          shouxiaokapi(nu){
              this.$parent.shouxiaokapicha(nu);
          },
          takeBoxkalayer(pcBatchId){
            this.$parent.takeBox(pcBatchId);
          }
    } 
}
</script>

<style scoped>
.ka-box{
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.7);
    top: 0;
    left:0;
    z-index: 9999;
}
.ka-box{
    display: block;
}
.ka-box-con{
    position: absolute;
    top: 50%;
    left: 50%;
    width: 76%;
    -webkit-transform: translate(-50%,-50%);
    -moz-transform: translate(-50%,-50%);
    -ms-transform: translate(-50%,-50%);
    -o-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
    max-width: 526px;
}
.ka-conten .lijiang{
    height: .92rem;
    line-height: .68rem;
    font-size: .32rem;
}
.ka-box-con .shouxia{
    display: block;
    margin: 0 auto;
    background: url(//i1.ulecdn.com/i/event/2018/0511/tencele/tan5.png) no-repeat center;
    background-size: 100% 100%;
    width: .86rem;
    height: .86rem;
    margin-top: .6rem;
}
.ka-box-con .car-pno{
    display: block;
    position: absolute;
    left: 50%;
    -webkit-transform: translateX(-50%);
    -moz-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    -o-transform: translateX(-50%);
    transform: translateX(-50%);
    width: 4.9rem;
    height: 2.8rem;
    top: 22%;
    text-align: center;
    color: #ea0550;
    padding-top: 1.4rem;
    font-size: .34rem;
    line-height: .5rem;
}
.ka-conten .pg{
    display: block;
    width: 100%;
    border-radius: .18rem;
}
.ka-conten .zi,.ka-conten .pai,.ka-conten .pd,.ka-conten .lijiang
{
    height:auto;
    display: block;
    position: absolute;
    left: 50%;
    -webkit-transform: translateX(-50%);
    -moz-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    -o-transform: translateX(-50%);
    transform: translateX(-50%);
}
.ka-conten .zi,.ka-conten .pai,.ka-conten .pd,.ka-conten .hcheng
{
    position: absolute;
    top: 83%;
    width: 100%;
    height: .66rem;
    background: url(//www.ule.com/app/yxd/event/2019/0730/douele/image/an11.png) no-repeat center;
    background-size: 100% 100%;
    z-index: 4;
    left: 0;
    display: block;
}
.ka-conten .zi{
    width: 27%;
    top: 2%;
    z-index: 1;
}
.ka-conten .pai{
    top: 27%;
    z-index: 2;
}
.ka-conten .pai.p1{
    width: 35%;
}
.ka-conten .pai.p2{
    width: 58%;
}
.ka-conten .pai.p3{
    width: 34%;
}
.ka-conten .pd{
    width: 72%;
    top: 38%;
    z-index: 3;
}
.ka-conten .lijiang{
    top: 72%;
    width: 70%;
    height: .89rem;
    background: url(//www.ule.com/app/yxd/event/2019/0730/twelve/images/jika/an6.png) no-repeat center;
    background-size: 100% 100%;
    z-index: 4;
}
.ka-conten .hcheng{
    top: 72%;
    width: 70%;
    height: .89rem;
    background: url(//www.ule.com/app/yxd/event/2019/0730/twelve/images/jika/an9.png) no-repeat center;
    background-size: 100% 100%;
    z-index: 4;
    left: 15%;
    display: block;
    position: absolute;
}
.ka-conten .jinli{
    top: 72%;
    width: 70%;
    height: .89rem;
    background: url(//www.ule.com/app/yxd/event/2019/0730/twelve/images/jika/an7.png) no-repeat center;
    background-size: 100% 100%;
    z-index: 4;
    left: 15%;
    display: block;
    position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/components/common/kalayer.vue